// AUTO GENERATED FILE - Changes WILL be lost.
// el - used as 'el' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Δελτίο",
  "product.last60-row-single": "NBA Τελευταία 60 Ενιαίος Αγώνας",
  "product.sb-english-single": "Αγγλικά Soccerbet Ενιαίος αγώνας",
  "product.sb-italian-single": "Ιταλικό Ποδόσφαιροbet Ενιαίος Αγώνας",
  "product.sb-greek-single": "Ελληνικό Ποδόσφαιροbet Ενιαίος Αγώνας",
  "product.sb-english-league": "Αγγλικό Πρωτάθλημα Ποδοσφαίρου",
  "product.sb-italian-league": "Ιταλικό Πρωτάθλημα Ποδοσφαίρου",
  "product.sb-greek-league": "Ελληνικό ποδόσφαιρο",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "ΣΤΟΙΧΗΜΑΤΙΣΕ",
  "betslip.clear": "ΔΙΑΓΡΑΦΗ ΟΛΩΝ",
  "betslip.clearResult": "ΔΙΑΓΡΑΦΗ",
  "betslip.noSelections": "Προσθέστε επιλογές για να ξεκινήσετε να ποντάρετε",
  "betslip.notLoggedIn": "Συνδεθείτε για να ποντάρετε",
  "betslip.refresh": "Ανανέωση",
  "betslip.totalStake": "ΠΟΝΤΑΡΙΣΜΑ",
  "betslip.noHistoryData": "Δεν υπάρχουν διαθέσιμες πληροφορίες στοιχήματος",
  "betslip.openBets": "Στοιχήματα",
  "betslip.betHistory": "Ιστορικό Στοιχημάτων",
  "betslip.betHistoryWon": "Κερδισμένο",
  "betslip.betHistoryLost": "Χαμένο",
  "loading.loading": "φόρτωση",
  "loading.account": "Φόρτωση λογαριασμού",
  "loading.league": "Φόρτωση Πρωταθλήματος",
  "loading.gameweeks": "Φόρτωση Αγωνιστικής",
  "loading.markets": "Φόρτωση Αγορών",
  "loading.bethistory": "φόρτωση ιστορικού στοιχημάτων",
  "login.loginRequired": "Χρειάζεται Σύνδεση",
  "login.loginToBet": "Συνδεθείτε για να ξεκινησετε να ποντάρετε",
  "navigation.back": "Πίσω",
  "navigation.close": "Κλείσιμο",
  "video.liveStreamAvailable": "Stream Διαθέσιμο",
  "video.logInToWatch": "Ζωντανο Βίντεο Διαθέσιμο Παρακαλούμε Συνδεθείτε",
  "error.error": "Σφάλμα",
  "error.404": "Η Σελίδα δεν βρέθηκε",
  "error.gameLaunchFailed": "Μη Δυνατοτητα φόρτωσης του παιχνιδιού",
  "error.unknownErrorCode": "Άγνωστο σφάλμα {code}",
  "error.minUnitStakeLimitExceeded": "Ελαχιστο Ποντάρισμα {limit}",
  "error.maxUnitStakeLimitExceeded": "Μέγιστο Ποντάρισμα {limit}",
  "error.minTotalStakeLimitExceeded": "Ελαχιστο Ποντάρισμα {limit}",
  "error.maxTotalStakeLimitExceeded": "Μέγιστο Ποντάρισμα {limit}",
  "error.stakeInvalidMultiple": "Το ποντάρισμα πρέπει να είναι πολλαπλάσιο {multiple}",
  "error.notPlaced": "Δεν τοποθετήθηκε",
  "error.wagerDisallowed": "Μη αποδεκτό στοίχημα",
  "error.errorEventIsOff": "Το παιχνίδι έχει ξεκινήσει",
  "multiplebet.Singles": "Μονά",
  "multiplebet.Doubles": "Διπλά",
  "multiplebet.Trebles": "Τριάδα",
  "multiplebet.Accumulator": "Παρολί",
  "multiplebet.Perm 4-Folds": "Τετράδες",
  "multiplebet.Perm 5-Folds": "Πεντάδες",
  "multiplebet.Perm 6-Folds": "Εξάδες",
  "multiplebet.Perm 7-Folds": "Επτάδες",
  "multiplebet.Perm 8-Folds": "Οκτάδες",
  "multiplebet.Perm 9-Folds": "Εννιάδες",
  "error.excess_bets": "Μέγιστο {limit} στοιχημάτων στο δελτίο. Παρακαλώ αφαιρέστε μια επιλογή",
  "product.sb-turkish-league": "Τουρκικό Πρωτάθλημα Ποδοσφαίρου",
  "error.minBetslipLimitExceeded": "Ελάχιστο ποσό πονταρίσματος {limit}",
  "error.maxBetslipLimitExceeded": "Μέγιστο ποσό πονταρίσματος {limit}",
  "error.exceededMaxPayout": "Μέγιστο ποσό επιστροφής {limit}",
  "betslip.potentialReturns": "Επιστροφή",
  "betslip.taxDisclaimer": "Τα καθαρά κέρδη φορολογούνται μετά την διευθέτηση του δελτίου. Το ποσό του φόρου θα υπολογιστεί ανάλογα με τα πιθανά κέρδη του δελτίου.",
  "error.maintenanceEnabled": "Οι υπηρεσίες μας δεν ειναι διαθέσιμες λόγω αναβάθμισης.",
  "sb-english.team.ARS": "ΑΡΣ",
  "sb-english.team.AST": "ΑΣΤ",
  "sb-english.team.BHA": "ΜΠΡ",
  "sb-english.team.BOU": "ΜΠΟΡ",
  "sb-english.team.BUR": "ΜΠΕΡ",
  "sb-english.team.CHE": "ΤΣΕΛ",
  "sb-english.team.CRY": "ΚΡΙΣ",
  "sb-english.team.EVE": "ΕΒΕ",
  "sb-english.team.LEI": "ΛΕΣ",
  "sb-english.team.LIV": "ΛΙΒ",
  "sb-english.team.MNC": "ΣΙΤΙ",
  "sb-english.team.MNU": "ΜΑΝ",
  "sb-english.team.NEW": "ΝΙΟΥΚ",
  "sb-english.team.SOU": "ΣΑΟΥ",
  "sb-english.team.TOT": "ΤΟΤ",
  "sb-english.team.WAT": "ΓΟΥ",
  "sb-english.team.WHU": "ΧΑΜ",
  "sb-english.team.WOL": "ΓΟΥ",
  "sb-english.team.NOR": "ΝΟΡ",
  "sb-english.team.SHU": "ΣΕΦ",
  "sb-english.team.LEE": "ΛΙΝ",
  "sb-english.team.FUL": "ΦΟΥ",
  "sb-english.team.WBA": "ΜΠΡΟΜ",
  "sb-greek.team.AEK": "AEK",
  "sb-greek.team.APS": "ΑΠΟΛ",
  "sb-greek.team.ARI": "ΑΡΗΣ",
  "sb-greek.team.AST": "ΑΣΤ",
  "sb-greek.team.ATR": "ΑΤΡΟ",
  "sb-greek.team.GIA": "ΠΑΣ",
  "sb-greek.team.LEV": "ΛΕΒ",
  "sb-greek.team.OFI": "ΟΦΗ",
  "sb-greek.team.OLM": "ΟΛΥ",
  "sb-greek.team.PTK": "ΠΑΟ",
  "sb-greek.team.PNS": "ΠΑΝ",
  "sb-greek.team.PAO": "ΠΑΟΚ",
  "sb-greek.team.PLT": "ΠΛΑΤ",
  "sb-greek.team.XAN": "ΑΟΞ",
  "sb-italian.team.MIL": "ΜΙΛ",
  "sb-italian.team.ATA": "ΑΤΑ",
  "sb-italian.team.BOL": "ΜΠΟ",
  "sb-italian.team.BRE": "ΜΠΡ",
  "sb-italian.team.CAG": "ΚΑΛ",
  "sb-italian.team.CHI": "ΚΙΕ",
  "sb-italian.team.FIO": "ΦΙΟ",
  "sb-italian.team.GEN": "ΤΖΕ",
  "sb-italian.team.INT": "ΙΝΤ",
  "sb-italian.team.JUV": "ΓΙΟΥ",
  "sb-italian.team.LAZ": "ΛΑΤ",
  "sb-italian.team.NAP": "ΝΑΠ",
  "sb-italian.team.ROM": "ΡΟΜ",
  "sb-italian.team.SAM": "ΣΑΜ",
  "sb-italian.team.UDI": "ΟΥΝΤ",
  "sb-italian.team.VER": "ΒΕΡ",
  "nomorebets": "OΧΙ ΑΛΛΑ ΣΤΟΙΧΗΜΑΤΑ",
  "playtime": "Χρόνος παιχνιδιού",
  "gameId": "Κωδ. Αγώνα",
  "noGames": "Δεν υπάρχουν διαθέσιμα παιχνίδια. Ελέγξτε ξανά σύντομα.",
  "Home": "ΓΗΠΕΔΟΥΧΟΣ",
  "Away": "ΦΙΛΟΞΕΝΟΥΜΕΝΟΣ",
  "Visitor": "ΦΙΛΟΞΕΝΟΥΜΕΝΟΣ",
  "rules": "Κανόνες",
  "soccerbet.gameWeek": "ΑΓΩΝΙΣΤΙΚΗ",
  "soccerbet.noGameWeeks": "Δεν υπάρχουν διαθέσιμες αγωνιστικές. Ελέξτε ξανά αργότερα",
  "soccerbet.league": "Βαθμολογία",
  "soccerbet.table.name": "Ονομα",
  "soccerbet.table.won": "Ν",
  "soccerbet.table.drawn": "Ι",
  "soccerbet.table.lost": "Η",
  "soccerbet.table.points": "Π",
  "market.abbr.Both Teams To Score": "GG/NG (BTTS)",
  "market.Both Teams To Score": "GG/NG (ΝΑ ΣΚΟΡΑΡΟΥΝ ΚΑΙ ΟΙ ΔΥΟ ΟΜΑΔΕΣ)",
  "market.Over / Under": "Over/Under",
  "market.Double Chance": "ΔΙΠΛΗ ΕΥΚΑΙΡΙΑ",
  "market.Match Result": "ΑΠΟΤΕΛΕΣΜΑ",
  "market.Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ",
  "market.Correct Score": "ΑΚΡΙΒΕΣ ΣΚΟΡ",
  "market.Match Result Both Score": "ΑΠΟΤΕΛΕΣΜΑ & ΝΑ ΣΚΟΡΑΡΟΥΝ ΚΑΙ ΟΙ 2 ΟΜΑΔΕΣ",
  "market.Result Und/Over 1.5 Total Goals": "ΑΠΟΤΕΛΕΣΜΑ ΚΑΙ Over/Under 1.5 ΓΚΟΛ",
  "market.Result Und/Over 2.5 Total Goals": "ΑΠΟΤΕΛΕΣΜΑ ΚΑΙ Over/Under 2.5 ΓΚΟΛ",
  "market.Under Over 1.5 Total Goals": "Over/Under 1.5 γκολ",
  "market.Under Over 2.5 Total Goals": "Over/Under 2.5 γκολ",
  "market.Under Over 3.5 Total Goals": "Over/Under 3.5 γκολ",
  "market.Under Over 4.5 Total Goals": "Over/Under 4.5 γκολ",
  "market.Total Goals 1 To 2": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-2",
  "market.Total Goals 1 To 3": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-3",
  "market.Total Goals 1 To 4": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 1-4",
  "market.Total Goals 2 To 3": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 2-3",
  "market.Total Goals 2 To 4": "ΣΥΝΟΛΙΚΑ ΓΚΟΛ 2-4",
  "market.Under Over 1.5 Home Goals": "Over/Under 1.5 ΓΚΟΛ ΓΗΠΕΔΟΥΧΟΥ",
  "market.Under Over 1.5 Away Goals": "Over/Under 1.5 ΓΚΟΛ ΦΙΛΟΞΕΝΟΥΜΕΝΟΥ",
  "market.Home Team Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ ΓΗΠΕΔΟΥΧΟΥ",
  "market.Away Team Exact Goals": "ΑΚΡΙΒΗΣ ΑΡΙΘΜΟΣ ΓΚΟΛ ΦΙΛΟΞΕΝΟΥΜΕΝΟΥ",
  "selection.Yes": "ΝΑΙ",
  "selection.No": "ΟΧΙ",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+ΝΑΙ",
  "selection.1+No": "1+ΟΧΙ",
  "selection.X+Yes": "X+ΝΑΙ",
  "selection.X+No": "X+ΟΧΙ",
  "selection.2+Yes": "2+ΝΑΙ",
  "selection.2+No": "2+ΟΧΙ",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "OVER",
  "selection.Under": "UNDER",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "ΑΠΟΛ",
  "sb-greek.team.abbr.ARI": "ΑΡΗΣ",
  "sb-greek.team.abbr.AST": "ΑΣΤ",
  "sb-greek.team.abbr.ATR": "ΑΤΡ",
  "sb-greek.team.abbr.GIA": "ΠΑΣ",
  "sb-greek.team.abbr.LEV": "ΛΕΒ",
  "sb-greek.team.abbr.OFI": "ΟΦΗ",
  "sb-greek.team.abbr.OLM": "ΟΛΥ",
  "sb-greek.team.abbr.PTK": "ΠΑΟ",
  "sb-greek.team.abbr.PNS": "ΠΓΣΣ",
  "sb-greek.team.abbr.PAO": "ΠΑΟΚ",
  "sb-greek.team.abbr.PLT": "ΠΛΑΤ",
  "sb-greek.team.abbr.XAN": "ΑΟΞ",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "BUR",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "CRS",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "ΜΠΡΕ",
  "sb-english.team.abbr.BRE": "ΜΠΡΕ",
  "market.Overall Winner": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ",
  "market.Last60 Winner": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Both Teams Over 2.5 Last60": "OVER 2.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Both Teams Over 3.5 Last60": "OVER 3.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.First Team To Score In Last60": "ΠΡΩΤΗ ΟΜΑΔΑ ΠΟΥ ΘΑ ΣΚΟΡΑΡΕΙ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Last60 Winner And Winning Margin": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΚΑΙ ΔΙΑΦΟΡΑ ΝΙΚΗΣ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.First To Score 4 Points Last60": "ΠΡΩΤΗ ΟΜΑΔΑ ΠΟΥ ΘΑ ΣΚΟΡΑΡΕΙ 4 ΠΟΝΤΟΥΣ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Home Under/Over 4.5 Last60": "{home} Over/Under 4.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} Over/Under 4.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Home Under/Over 5.5 Last60": "{home} Over/Under 5.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} Over/Under 5.5 ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Last60 Winner And O/U 11.5": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60 ΚΑΙ O/U 11.5",
  "market.Last60 Points Difference": "ΔΙΑΦΟΡΑ ΠΟΝΤΩΝ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "market.Total 3-Pointers Last60": "ΣΥΝΟΛΙΚΑ ΤΡΙΠΟΝΤΑ ΣΤΑ ΤΕΛΕΥΤΑΙΑ 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & Over",
  "selection.Home & Under": "{home} & Under",
  "selection.Visitor & Over": "{visitor} & Over",
  "selection.Visitor & Under": "{visitor} & Under",
  "last60.team.ATL": "ΑΤΛΑΝΤΑ ΧΟΚΣ",
  "last60.team.BKN": "ΜΠΟΡΥΚΛΙΝ ΝΕΤΣ",
  "last60.team.BOS": "ΜΠΟΣΤΟΝ ΣΕΛΤΙΚΣ",
  "last60.team.CHA": "ΣΑΡΛΟΤ ΧΟΡΝΕΤΣ",
  "last60.team.CHI": "ΣΙΚΑΓΟ ΜΠΟΥΛΣ",
  "last60.team.CLE": "ΚΛΙΒΕΛΑΝΤ ΚΑΒΑΛΙΕΡΣ",
  "last60.team.DAL": "ΝΤΑΛΑΣ ΜΑΒΕΡΙΚΣ",
  "last60.team.DEN": "ΝΤΕΝΒΕΡ ΝΑΓΚΕΤΣ",
  "last60.team.DET": "ΝΤΙΤΡΟΙΤ ΠΙΣΤΟΝΣ",
  "last60.team.GSW": "ΓΚΟΛΝΤΕΝ ΣΤΕΙΤ ΓΟΥΟΡΙΟΡΣ",
  "last60.team.HOU": "ΧΙΟΥΣΤΟΝ ΡΟΚΕΤΣ",
  "last60.team.IND": "ΙΝΤΙΑΝΑ ΠΕΙΣΕΡΣ",
  "last60.team.LAC": "ΛΟΣ ΑΝΤΖΕΛΕΣ ΚΛΙΠΕΡΣ",
  "last60.team.LAL": "ΛΟΣ ΑΝΤΖΕΛΕΣ ΛΕΙΚΕΡΣ",
  "last60.team.MEM": "ΜΕΜΦΙΣ ΓΚΡΙΖΛΙΣ",
  "last60.team.MIA": "ΜΑΪΑΜΙ ΧΙΤ",
  "last60.team.MIL": "ΜΙΛΓΟΥΟΚΙ ΜΠΑΚΣ",
  "last60.team.MIN": "ΜΙΝΕΣΟΤΑ ΤΙΜΠΕΡΓΟΥΛΒΣ",
  "last60.team.NOP": "ΝΙΟΥ ΟΡΛΕΑΝ ΠΕΛΙΚΑΝΣ",
  "last60.team.NYK": "ΝΙΟΤ ΓΙΟΡΚ ΝΙΚΣ",
  "last60.team.OKC": "ΟΚΛΑΧΟΜΑ ΣΙΤΙ ΘΑΝΤΕΡ",
  "last60.team.ORL": "ΟΡΛΑΝΤΟ ΜΑΤΖΙΚ",
  "last60.team.PHI": "ΦΙΛΑΔΕΛΦΕΙΑ 76ΕΡΣ",
  "last60.team.PHX": "ΦΟΙΝΙΞ ΣΑΝΣ",
  "last60.team.POR": "ΠΟΡΤΛΑΝΤ ΜΠΛΕΙΖΕΡΣ",
  "last60.team.SAC": "ΣΑΚΡΑΜΕΝΤΟ ΚΙΝΓΚΣ",
  "last60.team.SAS": "ΣΑΝ ΑΝΤΟΝΙΟ ΣΠΕΡΣ",
  "last60.team.TOR": "ΤΟΡΟΝΤΟ ΡΑΠΤΟΡΣ",
  "last60.team.UTA": "ΓΙΟΥΤΑ ΤΖΑΖ",
  "last60.team.WAS": "ΟΥΑΣΙΝΓΚΤΟΝ ΓΟΥΙΖΑΡΝΤΣ",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "ΣΥΝΟΛΙΚΑ ΤΡΙΠΟΝΤΑ ΣΤΑ 'ΤΕΛΕΥΤΑΙΑ 60'",
  "market.Last60 Winning Margin 1": "ΤΕΛΕΥΤΑΙΑ 60 ΠΕΡΙΘΩΡΙΟ ΝΙΚΗΣ",
  "market.Last60 Winning Margin 2": "ΤΕΛΕΥΤΑΙΑ 60 ΠΕΡΙΘΩΡΙΟ ΝΙΚΗΣ",
  "market.Last60 Winning Margin 3": "ΤΕΛΕΥΤΑΙΑ 60 ΠΕΡΙΘΩΡΙΟ ΝΙΚΗΣ",
  "market.Last60 Winner & Winning Margin 1": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΚΑΙ ΔΙΑΦΟΡΑ ΝΙΚΗΣ ΤΑ 'ΤΕΛΕΥΤΑΙΑ 60'",
  "market.Last60 Winner & Winning Margin 2": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΚΑΙ ΔΙΑΦΟΡΑ ΝΙΚΗΣ ΤΑ 'ΤΕΛΕΥΤΑΙΑ 60'",
  "market.Last60 Winner & Winning Margin 3": "ΝΙΚΗΤΗΣ ΑΓΩΝΑ ΚΑΙ ΔΙΑΦΟΡΑ ΝΙΚΗΣ ΤΑ 'ΤΕΛΕΥΤΑΙΑ 60'",
  "market.Total 3-Pointers Last60 1-3+": "ΣΥΝΟΛΙΚΑ ΤΡΙΠΟΝΤΑ ΣΤΑ 'ΤΕΛΕΥΤΑΙΑ 60'",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17+",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-14",
  "selection.Visitor & 15-16": "{visitor} & 15-16"
}
